//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { ConfigContext } from '@/contexts/ConfigContext';

/**
 * Access the config slice (app/xgt/memory config state + config methods).
 * Consumers that only need config subscribe here, so they re-render on config
 * changes only — not on unrelated dataset/query state changes.
 */
export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context)
    throw new Error('useConfig must be used within a ConfigProvider');

  return context;
}
